import { render } from "./MissaoVisaoObjetivos.vue?vue&type=template&id=4af4246a&scoped=true&lang=pug"
import script from "./MissaoVisaoObjetivos.vue?vue&type=script&setup=true&lang=js"
export * from "./MissaoVisaoObjetivos.vue?vue&type=script&setup=true&lang=js"

import "./MissaoVisaoObjetivos.vue?vue&type=style&index=0&id=4af4246a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af4246a"]])

export default __exports__